let $ = window.$

const slider = {
    loanAmountSliderContainer: $(),
    loanTermSliderContainer  : $(),
    loanAmountInput          : $(),
    loanTermInput            : $(),
    sliderControlButtons     : $(),
    amountButtons            : $(),
    termButtons              : $(),
    inputOldValue            : null,
    loanAmountSlider         : null,
    loanTermSlider           : null,
    cacheDom() {
        this.loanAmountSliderContainer = $('#loan-amount-slider')
        this.loanTermSliderContainer = $('#loan-term-slider')
        this.loanAmountInput = $('#loan_amount')
        this.loanTermInput = $('#loan_term')
        this.sliderControlButtons = $('.js-slider-control')
        this.amountButtons = $('.amount-button')
        this.termButtons = $('.term-button')

        this.loanAmountMin = parseInt($('#loan-amount-min').val())
        this.loanAmountMax = parseInt($('#loan-amount-max').val())
        this.loanAmountStep =parseInt($('#loan-amount-step').val())
		this.loanTermMin = parseInt($('#loan-term-min').val())
        this.loanTermMax = parseInt($('#loan-term-max').val())
        this.loanTermStep =parseInt($('#loan-term-step').val())
		
    },
    sliderInit() {
        let loanAmount = parseInt(this.loanAmountInput.attr('value'))
        let loanTerm = parseInt(this.loanTermInput.attr('value'))
        this.loanAmountSlider = this.loanAmountSliderContainer.slider({
            value: isNaN(loanAmount) ? this.loanAmountMax : loanAmount,
            min  : this.loanAmountMin,
            max  : this.loanAmountMax,
            step : this.loanAmountStep,
            range: 'min',
            slide: (event, ui) => {
                this.loanAmountInput.val(ui.value)
            }
        });
        this.loanTermSlider = this.loanTermSliderContainer.slider({
            value: isNaN(loanTerm) ? this.loanTermMin : loanTerm,
            min  : this.loanTermMin,
            max  : this.loanTermMax,
            step : this.loanTermStep,
            range: 'min',
            slide: (event, ui) => {
                this.loanTermInput.val(ui.value)
            }
        });

        this.loanAmountInput.val(this.loanAmountSlider.slider('value'))
        this.loanTermInput.val(this.loanTermSlider.slider('value'))
    },
    bindInputsToSlider() {

        this.loanTermInput.add(this.loanAmountInput).on('change', (event) => {
            let newValue = parseInt(event.target.value)
            let target = $(event.target)

            let input = target.is(this.loanAmountInput) ?
                this.loanAmountInput :
                target.is(this.loanTermInput) ? this.loanTermInput : $()

            let maxValue = input.is(this.loanAmountInput) ?
                this.loanAmountMax :
                input.is(this.loanTermInput) ? this.loanTermMax : null

            let minValue = input.is(this.loanAmountInput) ?
                this.loanAmountMin :
                input.is(this.loanTermInput) ? this.loanTermMin : null

            let targetSlider = input.is(this.loanAmountInput) ? this.loanAmountSlider : this.loanTermSlider

            if (isNaN(newValue) || newValue > maxValue || newValue < minValue) {
                input.val(this.inputOldValue)
                return
            }

            targetSlider.slider('value', newValue)
            input.val(newValue)
        })
    },
    saveOldInputValue() {
        $(document).on('focusin', 'input', (event) => {
            this.inputOldValue = event.target.value
        })
    },
    bindSliderControlButtons() {
        let handlerId;
        this.sliderControlButtons.on('mousedown touchstart', (event) => {
            let input = $(event.target).parent().siblings('input')
            let action = $(event.target).data('action')

            let maxValue = input.is(this.loanAmountInput) ?
                this.loanAmountMax :
                input.is(this.loanTermInput) ? this.loanTermMax : null

            let minValue = input.is(this.loanAmountInput) ?
                this.loanAmountMin :
                input.is(this.loanTermInput) ? this.loanTermMin : null

            let step = input.is(this.loanAmountInput) ? this.loanAmountStep : this.loanTermStep

            this.triggerInputChange({
                input,
                action,
                maxValue,
                minValue,
                step
            })

            handlerId = setInterval(() => {
                this.triggerInputChange({
                    input,
                    action,
                    maxValue,
                    minValue,
                    step
                })
            }, 250)

        }).on('mouseup mouseleave touchend', () => {
            clearInterval(handlerId)
        })
    },
    bindAmountButtons() {
        this.amountButtons.on('click', (event) => {
            event.preventDefault()
            let action = $(event.target).data('action')
            this.triggerInputChange({
                input: this.loanAmountInput,
                action: action,
                maxValue: this.loanAmountMax,
                minValue: this.loanAmountMin,
                step: this.loanAmountStep
            })
        });
    },
    bindTermButtons() {
        this.termButtons.on('click', (event) => {
            event.preventDefault()
            let action = $(event.target).data('action')
            this.triggerInputChange({
                input: this.loanTermInput,
                action: action,
                maxValue: this.loanTermMax,
                minValue: this.loanTermMin,
                step: this.loanTermStep
            })
        });
    },
    triggerInputChange: (options) => {
        let currentValue = parseInt(options.input.val())

        if (currentValue >= options.maxValue && options.action === 'increase') {
            return
        }

        if (currentValue <= options.minValue && options.action === 'decrease') {
            return
        }

        let newValue = options.action === 'increase' ?
            currentValue + options.step :
            options.action === 'decrease' ? currentValue - options.step : options.maxValue

        options.input.val(newValue)
        options.input.trigger('change')
    },
    init() {
        this.cacheDom()
        this.sliderInit()
        this.saveOldInputValue()
        this.bindInputsToSlider()
        this.bindSliderControlButtons()
        this.bindAmountButtons()
        this.bindTermButtons()
    }
}

$(() => slider.init())